/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinRulesMonitor.vue?vue&type=template&id=36dace6a&scoped=true"
import script from "./digitalTwinRulesMonitor.vue?vue&type=script&lang=js"
export * from "./digitalTwinRulesMonitor.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinRulesMonitor.vue?vue&type=style&index=0&id=36dace6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dace6a",
  null
  
)

export default component.exports